/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_Link_PrivacyInputs */

const en_landing_footer_link_privacy = /** @type {(inputs: Landing_Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy policy`)
};

/**
* | output |
* | --- |
* | "Privacy policy" |
*
* @param {Landing_Footer_Link_PrivacyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_footer_link_privacy = /** @type {((inputs?: Landing_Footer_Link_PrivacyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_Link_PrivacyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_footer_link_privacy(inputs)
});